import { render, staticRenderFns } from "./ModalUpdateMedia.vue?vue&type=template&id=db1595ea&"
import script from "./ModalUpdateMedia.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports